import { formatActivityParts } from "utils/formatLocalDateTime";

// Dates arrive as naive UTC strings like "2024-08-22 20:45:35"; make them a proper ISO string first
// (Safari won't parse the space) and show them as "22 Aug 2024, 8:45 PM IST" in the viewer's own zone.
export const formatCostCenterDate = (value) => {
  if (!value) return "—";
  const { date, time } = formatActivityParts(String(value).trim().replace(" ", "T"));
  return `${date}, ${time}`;
};

// The AI credit pool: how much of the target is currently in it. Both amounts can be missing.
export const getPoolSummary = (cc) => {
  const current = cc?.ai_credit_pool_state?.current_amount;
  const target = cc?.ai_credit_pool_state?.target_amount;
  if (typeof current !== "number" || typeof target !== "number" || target <= 0) {
    return { current: current ?? null, target: target ?? null, percent: null };
  }
  return { current, target, percent: Math.min(Math.round((current / target) * 100), 999) };
};

export const formatCredits = (value) =>
  typeof value === "number" ? value.toLocaleString("en-AU", { maximumFractionDigits: 0 }) : "—";

// A list field that the API sends as null when empty.
export const asList = (value) => (Array.isArray(value) ? value.filter(Boolean) : []);

// The scope fields shown on the detail page, in reading order.
export const SCOPE_FIELDS = [
  { key: "countries", label: "Countries" },
  { key: "business_functions", label: "Business functions" },
  { key: "departments", label: "Departments" },
  { key: "business_names", label: "Business names" },
  { key: "business_areas", label: "Business areas" },
  { key: "business_lines", label: "Business lines" },
];
